module.exports = __webpack_public_path__ + "img/billing_setor_kas.2b8053fe.svg";